import { Token } from '@nominex/nomiswap-sdk'
import { createSelector } from '@reduxjs/toolkit'
import { useWagmi } from 'libs/wagmi'
import { useSelector } from 'react-redux'
import { AppState } from 'state'
import { deserializeToken } from './helpers'

const selectUserTokens = ({ user: { tokens } }: AppState) => tokens

export const userAddedTokenSelector = (chainId: number) =>
  createSelector(selectUserTokens, (serializedTokensMap) =>
    Object.values(serializedTokensMap?.[chainId] ?? {}).map(deserializeToken),
  )
export default function useUserAddedTokens(): Token[] {
  const { chainId } = useWagmi()
  return useSelector(userAddedTokenSelector(chainId))
}
